import { render, staticRenderFns } from "./PropertyActions.vue?vue&type=template&id=60e6e4c6"
import script from "./PropertyActions.vue?vue&type=script&lang=js"
export * from "./PropertyActions.vue?vue&type=script&lang=js"
import style0 from "./PropertyActions.vue?vue&type=style&index=0&id=60e6e4c6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports